import QuantityButton from './QuantityButton';

export default QuantityButton;
